<digital-assets-sprite-svg></digital-assets-sprite-svg>
<arrow-left-icon-svg></arrow-left-icon-svg>
<div class="scorm-player-container">
  <div class="scorm-header">
    <a class="back-link" (click)="goBack()">
      <svg class="arrow-left">
        <use xlink:href="#arrowLeft"></use>
      </svg>
      <span>{{ "Back to Course" | translate }}</span>
    </a>
    
    <h1 class="course-title" *ngIf="courseTitle">{{courseTitle}}</h1>
    
    <div class="header-actions">
      <button class="fullscreen-button" (click)="toggleFullScreen()">
        <img [src]="fullScreenImgUrl" alt="fullscreen" class="fullscreen-icon" />
        <span>{{ "Full Screen" | translate }}</span>
      </button>

      <button class="certificate-button" (click)="openAssetsDialog()">
        <img [src]="certificateImgUrl" alt="certificate" class="certificate-icon" />
        <span>{{ "Get Certificate" | translate }}</span>
      </button>
    </div>
  </div>

  <div class="course-content-area">
    <div *ngIf="scormError" class="scorm-error">
      <p>Error: {{ scormError }}</p>
    </div>
    
    <div *ngIf="isScormLoading" class="loading">
      <span>Preparing course...</span>
    </div>

    <!-- Initial Launch State removed – course auto-launches -->
    
    <!-- After Launch - Show iframe -->
    <div *ngIf="scormLaunched && !scormError" class="iframe-container">
      <iframe 
        #scormFrame
        [src]="safeScormUrl" 
        class="scorm-iframe" 
        [class.hidden]="isScormLoading"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    </div>
  </div>
</div> 